import { render, staticRenderFns } from "./crf-list.vue?vue&type=template&id=f3b069c6&"
import script from "./crf-list.vue?vue&type=script&lang=ts&"
export * from "./crf-list.vue?vue&type=script&lang=ts&"
import style0 from "./crf-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports